import React from 'react'
import styles from '../../styles/solution.module.css';
import SectionTitle from '../common/SectionTitle';
import SolutionUseCasesCard from './SolutionUseCasesCard';
import { ICONPATH } from '../../constants/iconPath';
import { KR } from '../../constants/localizations';

export default function SolutionUseCases() {
    return (
        <div className={styles.case}>
            <SectionTitle title={KR.label_solution_case} titleEng={KR.label_solution_case_eng} />
            <div className={styles.cardW}>
                <SolutionUseCasesCard title={KR.label_solution_case_delivery_service} content={KR.label_solution_case_delivery_service_detail} icon={ICONPATH.boxD} />
                <SolutionUseCasesCard title={KR.label_solution_case_drone} content={KR.label_solution_case_drone_detail} icon={ICONPATH.drone} />
                <SolutionUseCasesCard title={KR.label_solution_case_protect} content={KR.label_solution_case_protect_detail} icon={ICONPATH.checkList} />
            </div>
        </div>
    )
}
